<template>
  <v-container class="pa-1">
    <v-btn small class="ma-0" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver al pasado
    </v-btn>

    <h4 class="text-center"> 
      Pre visualizacion del contrato, <b>Asegurese de revisar todos los datos</b> antes de proceder a generar/descargar
      el contrato.
    </h4>
    <v-divider></v-divider>

    <!-- -- {{ unidad_negocio }} {{ programa_tipo }} {{ programa_cuotas.length }} -->

    <div id="templatecontrato" v-show="false">
      <div v-if="existeMatricula">
        <ContratoTemplateMaes1 v-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Maestría' && programa_cuotas.length == 1" />
        <ContratoTemplateEsp1 v-else-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Especialidad' && programa_cuotas.length == 1" />
        <ContratoTemplate1 v-else-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Diplomado' && programa_cuotas.length == 1" />
        <ContratoTemplate1DBS v-else-if="unidad_negocio== 10 && programa_tipo == 'Diplomado' && programa_cuotas.length == 1" />

        <ContratoTemplateMaes2 v-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Maestría' && programa_cuotas.length == 2" />
        <ContratoTemplateEsp2 v-else-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Especialidad' && programa_cuotas.length == 2" />
        <ContratoTemplate2 v-else-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Diplomado' && programa_cuotas.length == 2" />
        <ContratoTemplate2DBS v-else-if="unidad_negocio== 10 && programa_tipo == 'Diplomado' && programa_cuotas.length == 2" />

        <ContratoTemplateMaes v-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Maestría' && programa_cuotas.length > 2" />
        <ContratoTemplateEsp v-else-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Especialidad' && programa_cuotas.length > 2" />
        <ContratoTemplate v-else-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Diplomado' && programa_cuotas.length > 2" />
        <ContratoTemplateDBS v-else-if="unidad_negocio== 10 && programa_tipo == 'Diplomado' && programa_cuotas.length > 2" />
      </div>
      <div v-else>
        <ContratoTemplateMaes2 v-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Maestría'" />
        <ContratoTemplateEsp2 v-else-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Especialidad'" />
        <ContratoTemplate2 v-else-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Diplomado'" />
        <ContratoTemplate2DBS v-else-if="unidad_negocio== 10 && programa_tipo == 'Diplomado'" />
      </div>
    </div>
    <div v-if="(unidad_negocio== 1 || unidad_negocio==5) && programa_tipo == 'Diplomado' && xinscripcion.programa.universidad.id == 2" v-show="false">
      <div id="templatejurada">
        <DeclaracionTemplateDiplo />
      </div>
    </div>

    <div ref="previewcontratodiv">
      <div id="templatecontratopreview" class="letritas"></div>
    </div>

    <div>
      <v-divider></v-divider>
      <p class="text-center blue--text" v-if="programa_tipo == 'Diplomado'">
        <b>NOTA:</b> La declaracion voluntaria esta disponible para los diplomados con la UAJMS
      </p>
      <div id="templatejuradapreview"></div>
    </div>

    <v-progress-linear v-if="loading" indeterminate />

    <p class="text-center red--text">{{ msg }}</p>
    <div vv-if="!loading">
      <v-divider class="mt-14 mb-3"></v-divider>
      <v-alert dense text type="error" class="text-center">
        <b>AVISO:</b> Revise la información de módulos y datos sensibles (texto en color ROJO) <strong>antes</strong> de
        <strong>generar/descargar</strong> el contrato, ya que una vez generado <b>no podrá ser modificado</b>.
      </v-alert>
    </div>

    <v-row v-if="contratosaved.length == 0 && !loading" class="row justify-center" no-cols-gutters>
      <div class="col-12 col-sm-6 col-lg-4">
        <v-alert dense text type="info" class="text-center">
          <v-switch label="Enviar contrato por correo" light v-model="enviar_por_correo" inset ></v-switch>
          <span v-if="enviar_por_correo">Al marcar esta opcion, se le hara llegar al estudiante su contrato al correo proporcionado </span>
          <p v-if="enviar_por_correo" class="ma-0 pa-0">
            <small> {{ correo_contrato }} </small> <v-btn small color="orange" @click="dialog=true"> <v-icon small>mdi-pencil</v-icon> </v-btn>
          </p>
        </v-alert>
      </div>
    </v-row>

    <div v-if="contratosaved.length > 0" class="text-center">
      <p class="text-center" style="font-size:1.3em">Este estudiante ya tiene un contrato generado.</p>
      <v-btn small dark class="green" @click="descargarcontrato()"> Descargar generado </v-btn>
    </div> 

    <div class="text-center mb-10" v-else-if="!loading">
      <v-switch
        v-show="unidad_negocio != 10"
        :label="'Descargar en un solo archivo: ' + (only_file ? 'SI' : 'NO')"
        v-model="only_file"
        dense
        inset
      ></v-switch>
      <p class="my-0 text-center blue--text">
        Se generara un codigo de contrato al momento de descargarlo en PDF
      </p>
      <button class="btn btn-success" @click="descargarpdf()" :disabled="generated">
        <span class="glyphicon glyphicon-download-alt white--text"></span> Descargar
        {{ getcantidadcopias() }} Ejemplares (PDF)
      </button>
    </div>

    <!-- <button class="btn btn-success" @click="descargarOnlyPDFTest()" :disabled="generated">
      <span class="glyphicon glyphicon-download-alt white--text"></span> Descargar Test
      {{ getcantidadcopias() }} Ejemplares (PDF)
    </button> -->

    <!-- <button class="btn btn-success" @click="descargarSladiaPDFTest()" :disabled="generated">
      <span class="glyphicon glyphicon-download-alt white--text"></span> Descargar Sladia Test
      {{ getcantidadcopias() }} Ejemplares (PDF)
    </button> -->

    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>

    <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialog"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar color="primary" dark >Correo del participante</v-toolbar>
            <v-card-text class="pt-4">
              <v-text-field label="Outlined" outlined v-model.trim="correo_contrato"></v-text-field>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="dialog.value = false" color="green">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
  </v-container>
</template>

<style>
  table tbody td:first-child {
    background: white !important;
    text-align: center !important;
    position: relative !important;
  }

  .tablecita tbody td {
    border-top: 2px solid white;
    border-bottom: 2px solid #a2a2a2;
  }
  .tablecita tbody tr {
    border: 1px solid #a2a2a2;
  }

  tbody td:nth-child(2) {
    color: black;
  }
  ul {
    list-style-type: square;
  }
  .letritas {
    font-size: 1em;
  }
</style>

<script>
  import { mapState } from 'vuex';
  import xaxios from '@/xaxios';
  import ContratoTemplate from '../views/contratos/credito/template-diplo.vue';
  import ContratoTemplateDBS from '../views/contratos/credito/template-diplo-dbs.vue';
  import ContratoTemplateMaes from '../views/contratos/credito/template-maes.vue';
  import ContratoTemplateEsp from '../views/contratos/credito/template-espe.vue';

  import ContratoTemplate1 from '../views/contratos/cuotas1/template-diplo.vue';
  import ContratoTemplate1DBS from '../views/contratos/cuotas1/template-diplo-dbs.vue';
  import ContratoTemplateMaes1 from '../views/contratos/cuotas1/template-maes.vue';
  import ContratoTemplateEsp1 from '../views/contratos/cuotas1/template-espe.vue';

  import ContratoTemplate2 from '../views/contratos/cuotas2/template-diplo.vue';
  import ContratoTemplate2DBS from '../views/contratos/cuotas2/template-diplo-dbs.vue';
  import ContratoTemplateMaes2 from '../views/contratos/cuotas2/template-maes.vue';
  import ContratoTemplateEsp2 from '../views/contratos/cuotas2/template-espe.vue';
  import DeclaracionTemplateDiplo from '../views/contratos/declaracion-jurada.vue';
  import gql from 'graphql-tag';
  export default {
    data() {
      return {
        msg: '',
        programa_tipo: '',
        unidad_negocio: '',
        only_file: false,
        enviar_por_correo: false,
        url_firma: '',
        loading: false,
        dialog: false,
        generated: false,
        existeMatricula: false,
        api_rest: process.env.VUE_APP_API_REST,
        msg_fallas: '',
        xapoderado: {},
        xinscripcion: {},
        inscripcion: {},
        contratosaved: [],
        sede: {},
        inputcontrato: {},
        programa_cuotas: [],
        correo_contrato:'',
      };
    },
    components: {
      ContratoTemplate,
      ContratoTemplateMaes,
      ContratoTemplateEsp,
      ContratoTemplate1,
      ContratoTemplateMaes1,
      ContratoTemplateEsp1,
      ContratoTemplate2,
      ContratoTemplateMaes2,
      ContratoTemplateEsp2,
      DeclaracionTemplateDiplo,

      ContratoTemplateDBS,
      ContratoTemplate1DBS,
      ContratoTemplate2DBS,
    },
    computed: { ...mapState({ programa: (state) => state.programa.value }) },
    watch: {},
    methods: {
      getcantidadcopias() {
        if (!this.xinscripcion.programa) return 1;
        let cate = this.xinscripcion.programa.postgrado.categoria.id;
        if (cate == 1) return 3;
        else if (cate == 24) return 1;
        else return 4;
      },
      getsede(idprograma) {
        this.loading = true;
        let idsede = this.$store.state.CARGO.sede.id;
        var sql = gql`query{ getSede(id:${idsede}){id,nombre,direccion, ciudad{nombre}, gerente{firma,datos_personales{id,num_doc,nombres,pri_apellido,seg_apellido, departamento{id, nombre, extension}}} } }`;
        //window.console.log('\n', sql);
        this.$apollo
          .query({ query: sql })
          .then((data) => {
            this.sede = data.data.getSede;
            this.xapoderado = this.sede.gerente.datos_personales;
            this.url_firma = process.env.VUE_APP_URL_BG_FIRMA_USER + this.sede.gerente.firma;
            if (!this.sede.ciudad) this.sede.ciudad = { nombre: '' };
            if (!this.sede.departamento) this.sede.departamento = { nombre: '', extension: '' };
            this.getPrograma(idprograma);
          })
          .catch((error) => {
            this.msg = error;
            window.console.error(error);
          });
      },
      getPrograma(idprograma) {
        var vue = this;
        //var sql = gql`query{ getPrograma(id:${this.idprograma}){arte,universidad{nombre,convenio,id},sede{id,nombre,correos{tipo,direccion}},inscripciones{observaciones,certificado_id,id,estado_ins,fecha_registro,asesor{id},estudiante{id,email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,sexo,departamento{extension},profesiones{id,nombre},pais{nombre},estado,institucion{id,nombre,abreviatura},domicilio,fecha_nac,est_civil},asesor{num_doc,num_doc,nombres,pri_apellido,seg_apellido},programa{id,nombre_compuesto,version,grupo,fecha_inicio,fecha_fin,sede{id,nombre,ciudad{nombre}},postgrado{nombre,creditaje,carga_horaria,categoria{nombre}}}}}}`;
        var sql = gql`query{ getPrograma(id:${idprograma}){arte,nombre_compuesto,modalidad,universidad{id,nombre},programa_modulos{numero,modulo{nombre,sigla,tipo}},sede{id,nombre,ciudad{nombre}},id,postgrado{nombre,creditaje,carga_horaria,categoria{id, nombre}}}}`;
        //var sql = gql`query{ getPrograma(id:${this.idprograma}){inscripciones{id,estado_ins,fecha_registro,estudiante{id,email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,sexo,departamento{extension},profesiones{nombre},institucion{nombre,abreviatura},estado,domicilio,fecha_nac,est_civil},asesor{id,num_doc,nombres,pri_apellido,seg_apellido}}}}`;
        this.$apollo
          .query({
            query: sql,
          })
          .then((data) => {
            vue.xinscripcion.programa = data.data.getPrograma;
            vue.getpersonadata();
            //window.console.log('>',JSON.stringify(data.data.getPrograma, null, 4), vue);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
      getpersonadata() {
        if (!this.xinscripcion.programa.universidad) this.xinscripcion.programa.universidad = {};
        //window.console.log('this.xinscripcion.programa', this.xinscripcion.programa);
        let persona_id = this.xinscripcion.estudiante.id;
        let inscripcion_id = this.xinscripcion.id;
        this.programa_tipo = this.xinscripcion.programa.postgrado.categoria.nombre;
        this.unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
        this.loading = true;
        const vue = this;
        let idsede = this.$store.state.CARGO.sede.id;
        //const url = `${this.api_rest}/api/esam/inscripcion/estudiante/id/${persona_id}`;
        // const url = `${this.api_rest}/api/v1/esam/inscripcion/estudiante/id/${persona_id}`;
        // let url4 = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${inscripcion_id}/plan-pago/kardex`;
        //const promise1 = axios.get(url);
        let url2 = `${process.env.VUE_APP_API_REST}/api/v1/user/cargos?sede_id=${idsede}&cargos=3`; // 3 = gerente regional
        let url3 = `${process.env.VUE_APP_API_REST}/api/v1/contratos/${persona_id}/persona`;
        let url5 = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${inscripcion_id}/plan-pago`;
        const promise2 = xaxios.get(url2);
        const promise3 = xaxios.get(url3);
        const promise5 = xaxios.get(url5); 
        //window.console.log("INS ID:::",inscripcion_id);

        Promise.all([promise2, promise3, promise5])
          .then(function(values) {
            //let data = values[0].data; // aumentar .data para el nuevo endpoint plan pagos
            //let data4 = values[3].data;
            //let data2 = values[1].data.data;
            //if (!data2) data2 = [];
            //vue.inscripcion = data.find((ins) => ins.id === inscripcion_id);
            //window.console.log('vue.inscripcion.plan_pagos', vue.inscripcion.plan_pagos);
            let data3 = values[1].data;
            let data5 = values[2].data;
            if (!data3) data3 = { data: [] };
            if (!data3.data) data3.data = [];
            //vue.contratosaved = data3.data; //version anterior
            // window.console.log('>>>>>>>>>>> data3',data3);
            data3.data.sort((a,b)=>a.id - b.id);
            vue.contratosaved = data3.data.filter(x=>{return x.inscripcion_id==inscripcion_id});
            vue.inscripcion = {};

            // window.console.log('contratosaved:',vue.contratosaved);

            // window.console.log(vue.inscripcion);
            let plan = data5.data.map((item) => ({
              ...item,
              saldo:
                item.total -
                (item.monto_pagado +
                  item.monto_descuento +
                  item.monto_regularizado +
                  item.monto_compensacion +
                  item.monto_liquido),
            }));
            // window.console.log('plan-pago::', plan);
            //window.console.log('data4', data4.data);
            vue.inscripcion.plan_pagos = plan;
            vue.programa_cuotas = vue.inscripcion.plan_pagos.filter((x) => {
              return x.concepto_pago_id == 2;
            });
            vue.existeMatricula = false;
            vue.inscripcion.plan_pagos.forEach((x) => {
              if (x.concepto_pago_id == 1 && x.total > 0) vue.existeMatricula = true;
            });

            //vue.xapoderado = data2[0];
            //if (!vue.xapoderado) vue.xapoderado = {};
            //window.console.log('persona-contrato: ', vue.programa, vue.xinscripcion, data, vue.inscripcion);
            //window.console.log('persona-contrato: ', vue.programa, vue.xinscripcion, data, vue.inscripcion);
            setTimeout(() => {
              vue.templateToString();
            }, 200);
          })
          .catch((e) => {
            vue.$emit('dataloaded');
            window.console.error(e);
            vue.loading = false;
          });

        /*axios.get(url).then(({ data }) => {
            this.inscripcion = data.find((ins) => ins.id === inscripcion_id);
            window.console.log('persona-contrato: ', this.programa, this.xinscripcion, data, this.inscripcion);
            //this.xgenerarContrato();
            this.templateToString();
          });*/
      },
      getdia_cada_mes(fechapago) {
        let date = new Date(fechapago);
        let dia = date.getDate() + 1;
        return dia;
      },
      templateToString() {
        //window.console.log(JSON.stringify(this.xinscripcion.programa.programa_modulos, null, 4));
        const writtenNumber = require('written-number');
        if (!this.inscripcion.plan_pagos) this.inscripcion.plan_pagos = [];
        this.msg_fallas = '';
        const vue = this;

        let date = new Date();
        let dia = date.getDate();
        let mes = date.getMonth() + 1;
        let anio = date.getFullYear();
        let n = `${this.xapoderado.nombres} ${this.xapoderado.pri_apellido} ${this.xapoderado.seg_apellido}`;
        n = n.replaceAll('null','');
        // if(this.unidad_negocio == 5) n = '';
        this.correo_contrato = this.xinscripcion.estudiante.email;
        let apoderado_esam = n;
        let apoderado_ci_esam = this.xapoderado.num_doc;
        let apoderado_ci_ext_esam = this.xapoderado.departamento.extension;
        let estudiante = this.xinscripcion.estudiante.nombres + ' ' + this.xinscripcion.estudiante.pri_apellido;
        let nacionalidad = 'null';
        let carnet = this.xinscripcion.estudiante.num_doc;
        let domicilio = this.xinscripcion.estudiante.domicilio;
        let telefono1 = this.xinscripcion.estudiante.telefono1;
        let programa_tipo = this.xinscripcion.programa.postgrado.categoria.nombre;
        let programa_nombre = this.xinscripcion.programa.nombre_compuesto;
        let programa_carga_horaria = this.xinscripcion.programa.postgrado.carga_horaria;
        let programa_monto = 0;
        let saldo_colegiatura = 0;
        let programa_matricula_monto = 0;
        let modalidad = '';
        let yodeclaro = 'Declaro ser deudor del programa';
        if (this.xinscripcion.programa.modalidad == 'V') modalidad = 'Virtual';
        else if (this.xinscripcion.programa.modalidad == 'P') modalidad = 'Presencial';
        else if (this.xinscripcion.programa.modalidad == 'S') modalidad = 'Semi presencial';
        if (this.xinscripcion.estudiante.pais) nacionalidad = this.xinscripcion.estudiante.pais.nombre;
        /*let programa_cuotas = this.inscripcion.plan_pagos.filter((x) => {
          return x.concepto_pago_id == 2;
        });*/

        if (!this.xinscripcion.programa.universidad)
          this.xinscripcion.programa.universidad = { nombre: 'UNIVERSIDAD NACIONAL SIGLO XX' };

        if(!this.xinscripcion.programa.universidad.nombre){
          this.xinscripcion.programa.universidad.nombre = "";
        }

        //window.console.log("<><><><>,",this.xinscripcion.programa);

        let universidad_name = this.xinscripcion.programa.universidad.nombre.toUpperCase();
        let ciudad = this.xinscripcion.programa.sede.ciudad.nombre;
        let filas = '';
        let filasm = '';
        let xmodulos = [];
        let xplanes = [];
        let dia_cada_mes = '15';

        //let reso_universidad = `la ${universidad_name}. (vigente a la fecha R.R. N° 009/17).`;

        this.inscripcion.plan_pagos.forEach((x) => {
          //window.console.log('paln pago', x);
          if (x.nro_cuota == 2 && x.concepto_pago_id == 2) dia_cada_mes = vue.getdia_cada_mes(x.fecha_pago);

          if (x.concepto_pago_id == 1) programa_matricula_monto += x.total - x.monto_descuento;
          // 1 es matricula???
          else if (x.concepto_pago_id == 2) {
            programa_monto += x.total - x.monto_descuento; // sera el monto incluyendo certificacion?
            saldo_colegiatura += x.saldo;
          }

          if (this.xinscripcion.programa.universidad.id == 2 && x.concepto_pago_id != 3) {
            filas += `<tr style="text-align:center;border: 1px solid #999999;height:1.8em; color: black!important;">
            <td>${x.nro_cuota}</td>
            <td>${x.concepto_pago}</td>
            <td style="color:black">${this.parsecomas(x.total - x.monto_descuento)}</td>
            <td>${x.saldo == 0 ? 'CANCELADO' : vue.getfecha(x.fecha_pago)}</td>
            </tr>`;
            xplanes.push({
              concepto_pago: x.concepto_pago,
              fecha_pago: x.fecha_pago,
              monto: x.total,
              nro_cuota: x.nro_cuota,
            });
          } else if (this.xinscripcion.programa.universidad.id != 2) {
            filas += `<tr style="text-align:center;border: 1px solid #999999;height:1.8em; color: black!important;">
            <td>${x.nro_cuota}</td>
            <td style="color:black!important;">${x.concepto_pago}</td>
            <td style="color:black">${this.parsecomas(x.total - x.monto_descuento)}</td>
            <td>${x.saldo == 0 ? 'CANCELADO' : vue.getfecha(x.fecha_pago)}</td>
            </tr>`;
            xplanes.push({
              concepto_pago: x.concepto_pago,
              fecha_pago: x.fecha_pago,
              monto: x.total,
              nro_cuota: x.nro_cuota,
            });
          }
        });
        if (saldo_colegiatura == 0) {
          yodeclaro = 'Declaro haber cancelado el costo del programa ';
        }

        //if (dia_cada_mes > 15) dia_cada_mes = 15;

        window.console.log('dia_cada_mes:::', dia_cada_mes);
        if (this.xinscripcion.programa.programa_modulos) {
          this.xinscripcion.programa.programa_modulos.sort((a, b) => {
            return a.numero - b.numero;
          });
        }

        if (this.xinscripcion.programa.universidad.id == 2) {
          this.xinscripcion.programa.programa_modulos = this.xinscripcion.programa.programa_modulos.filter((x) => {
            return x.numero;
          });
        }

        this.xinscripcion.programa.programa_modulos.forEach((x) => {
          filasm += `<tr style="text-align:left; border: 1px solid #999999;height:1.7em">
              <td style="text-align:center">${x.numero}</td>
              <td style="color: black">${(x.modulo.nombre+'').toUpperCase()}</td>
              </tr>`;
          xmodulos.push({ modulo: x.modulo.nombre, numero: x.numero, sigla: x.modulo.sigla, tipo: x.modulo.tipo });
        });
        if (this.xinscripcion.estudiante.seg_apellido) estudiante += ' ' + this.xinscripcion.estudiante.seg_apellido;
        if (this.xinscripcion.estudiante.departamento)
          carnet += ' ' + this.xinscripcion.estudiante.departamento.extension;

        if (nacionalidad == 'Bolivia') nacionalidad = 'Boliviana';
        //if (this.xinscripcion.estudiante.pais) nacionalidad = this.xinscripcion.estudiante.pais.nombre;
        //else nacionalidad = '-';
        //if (!domicilio) domicilio = '-';
        if (!nacionalidad) {
          this.$root.$notify.show('Falta la nacionalidad del participante.', { color: 'red' });
        }
        if (!domicilio) {
          this.$root.$notify.show('Falta el domicilio del participante.', { color: 'red' });
        }
        programa_nombre = programa_nombre.replace(/(\(.+\))/g, '').toUpperCase();
        let programa_colegiatura_monto = programa_monto;
        let programa_colegiatura_contado = programa_monto;
        let programa_mora_monto = 100; // revisar esto
        let mes_str = this.getmesstr(mes);

        let xprograma_matricula_monto = programa_matricula_monto;
        let xprograma_colegiatura_monto = programa_colegiatura_monto;
        let xprograma_colegiatura_contado = programa_colegiatura_contado;
        let xprograma_monto = programa_monto;
        let programa_monto_plus_matricula = this.parsecomas(programa_monto + programa_matricula_monto);
        let programa_monto_plus_matricula_str = writtenNumber(programa_monto + programa_matricula_monto, {
          lang: 'es',
        });

        programa_monto = this.parsecomas(programa_monto);
        programa_matricula_monto = this.parsecomas(programa_matricula_monto);
        programa_colegiatura_monto = this.parsecomas(programa_colegiatura_monto);
        programa_colegiatura_contado = this.parsecomas(programa_colegiatura_contado);

        let anio_str = writtenNumber(anio, { lang: 'es' });
        let programa_monto_str = writtenNumber(programa_monto, { lang: 'es' });
        let programa_matricula_monto_str = writtenNumber(programa_matricula_monto, { lang: 'es' });
        let programa_colegiatura_monto_str = writtenNumber(xprograma_colegiatura_monto, { lang: 'es' });
        //window.console.log('programa_colegiatura_monto_str',programa_colegiatura_monto_str,xprograma_colegiatura_monto);
        let programa_colegiatura_contado_str = writtenNumber(programa_colegiatura_contado, { lang: 'es' });
        let numods = this.xinscripcion.programa.programa_modulos.length;
        let expedido = this.xapoderado.departamento.nombre;
        // let costo_tramites = `Costo de trámites de Titulación ${programa_tipo}, Sujeto a RESOLUCIÓNRECTORAL Universitario de ${reso_universidad}`;
        //if (this.xinscripcion.programa.universidad.id == 2) costo_tramites = ''; // es UAJMS no va titulaciones
        let costo_tramites = '';

        let tabla_plan_pagos = `
          <div style="margin-left:auto; margin-right:auto; margin-bottom:1.5em; width:400px; font-size:0.95em; border: 1px solid #CACACA; color: black">
            <table class="tablecita" style="width:100%; border:1px solid #CACACA;">
              <thead>
                <tr style="border: 1px solid #CACACA;height:1.8em;color:black">
                  <th style="text-align:center">Cuota Nº</th>
                  <th style="text-align:center">Concepto</th>
                  <th style="text-align:center">Monto</th>
                  <th style="text-align:center">Fecha Vencimiento</th>
                </tr>
              </thead>
              <tbody>
                ${filas}
              </tbody>
            </table>
            <small><small style="line-height:inherit"> ${costo_tramites} </small></small>
          </div>
          `;

        let tabla_modulos = `
          <div style="margin-left:auto; margin-right:auto; margin-bottom:1.5em; width:500px; font-size:0.95em; border: 1px solid #CACACA; color: black">
            <table class="tablecita" style="width:100%; border:1px solid #999999;">
              <thead>
                <tr style="border: 1px solid #999999;height:1.8em">
                  <th style="text-align:center; min-width:50px;color: black">N. º</th>
                  <th style="text-align:center;color: black">MÓDULOS</th>
                </tr>
              </thead>
              <tbody>
                ${filasm}
              </tbody>
            </table>
          </div>
          `;

        let preview = window.$('#templatecontratopreview');
        let template = window.$('#templatecontrato').html();
        let previewjurada = window.$('#templatejuradapreview');
        let templatejurada = window.$('#templatejurada').html();
        template = template.replace(/{participante}/g, estudiante);
        template = template.replace(/{participante_nacionalidad}/g, nacionalidad);
        template = template.replace(/{participante_ci}/g, carnet);
        template = template.replace(/{participante_domicilio}/g, domicilio);
        template = template.replace(/{participante_telefono1}/g, telefono1);
        template = template.replace(/{programa_tipo}/g, programa_tipo);
        template = template.replace(/{programa_nombre}/g, programa_nombre);
        template = template.replace(/{programa_carga_horaria}/g, programa_carga_horaria);
        template = template.replace(/{programa_monto}/g, programa_monto);
        template = template.replace(/{programa_monto_plus_matricula}/g, programa_monto_plus_matricula);
        template = template.replace(/{programa_matricula_monto}/g, programa_matricula_monto);
        template = template.replace(/{programa_colegiatura_monto}/g, programa_colegiatura_monto);
        template = template.replace(/{programa_colegiatura_contado}/g, programa_colegiatura_contado);
        template = template.replace(/{programa_mora_monto}/g, programa_mora_monto);
        template = template.replace(/{programa_cuotas}/g, this.programa_cuotas.length);
        template = template.replace(/{programa_cuotas_str}/g, this.programa_cuotas.length > 1 ? ' cuotas' : ' cuota');
        template = template.replace(/{ciudad}/g, ciudad);
        template = template.replace(/{direccion_sede}/g, this.sede.direccion);
        template = template.replace(/{ciudad_sede}/g, this.sede.ciudad.nombre);
        template = template.replace(/{dias}/g, dia);
        template = template.replace(/{mes}/g, mes_str);
        template = template.replace(/{tabla_plan_pagos}/g, tabla_plan_pagos);
        template = template.replace(/{tabla_modulos}/g, tabla_modulos);
        template = template.replace(/{programa_modulos}/g, numods);
        template = template.replace(/{apoderado_esam}/g, apoderado_esam);
        template = template.replace(/{apoderado_ci_esam}/g, apoderado_ci_esam);
        template = template.replace(/{apoderado_ci_ext_esam}/g, apoderado_ci_ext_esam);
        template = template.replace(/{representante_ci_exp}/g, expedido);
        template = template.replace(/{programa_monto_str}/g, programa_monto_str);
        template = template.replace(/{programa_monto_plus_matricula_str}/g, programa_monto_plus_matricula_str);
        template = template.replace(/{programa_matricula_monto_str}/g, programa_matricula_monto_str);
        template = template.replace(/{programa_colegiatura_monto_str}/g, programa_colegiatura_monto_str );
        template = template.replace(/{programa_colegiatura_contado_str}/g, programa_colegiatura_contado_str);
        template = template.replace(/{anio_str}/g, anio_str);
        template = template.replace(/{dia_cada_mes}/g, dia_cada_mes);
        template = template.replace(/{universidad_name}/g, universidad_name);
        template = template.replace(/{modalidad}/g, modalidad);

        if (templatejurada) {
          templatejurada = templatejurada.replace(/{participante}/g, estudiante);
          templatejurada = templatejurada.replace(/{participante_nacionalidad}/g, nacionalidad);
          templatejurada = templatejurada.replace(/{participante_ci}/g, carnet);
          templatejurada = templatejurada.replace(/{participante_domicilio}/g, domicilio);
          templatejurada = templatejurada.replace(/{participante_telefono1}/g, telefono1);
          templatejurada = templatejurada.replace(/{programa_tipo}/g, programa_tipo);
          templatejurada = templatejurada.replace(/{programa_nombre}/g, programa_nombre);
          templatejurada = templatejurada.replace(/{programa_carga_horaria}/g, programa_carga_horaria);
          templatejurada = templatejurada.replace(/{programa_monto}/g, programa_monto);
          templatejurada = templatejurada.replace(/{programa_monto_plus_matricula}/g, programa_monto_plus_matricula);
          templatejurada = templatejurada.replace(/{programa_matricula_monto}/g, programa_matricula_monto);
          templatejurada = templatejurada.replace(/{programa_colegiatura_monto}/g, programa_colegiatura_monto);
          templatejurada = templatejurada.replace(/{programa_colegiatura_contado}/g, programa_colegiatura_contado);
          templatejurada = templatejurada.replace(/{programa_mora_monto}/g, programa_mora_monto);
          templatejurada = templatejurada.replace(/{programa_cuotas}/g, this.programa_cuotas.length);
          templatejurada = templatejurada.replace(/{yodeclaro}/g, yodeclaro);
          templatejurada = templatejurada.replace(
            /{programa_cuotas_str}/g,
            this.programa_cuotas.length > 1 ? ' cuotas' : ' cuota',
          );
          templatejurada = templatejurada.replace(/{ciudad}/g, ciudad);
          templatejurada = templatejurada.replace(/{direccion_sede}/g, this.sede.direccion);
          templatejurada = templatejurada.replace(/{ciudad_sede}/g, this.sede.ciudad.nombre);
          templatejurada = templatejurada.replace(/{dias}/g, dia);
          templatejurada = templatejurada.replace(/{mes}/g, mes_str);
          templatejurada = templatejurada.replace(/{tabla_plan_pagos}/g, tabla_plan_pagos);
          templatejurada = templatejurada.replace(/{tabla_modulos}/g, tabla_modulos);
          templatejurada = templatejurada.replace(/{programa_modulos}/g, numods);
          templatejurada = templatejurada.replace(/{apoderado_esam}/g, apoderado_esam);
          templatejurada = templatejurada.replace(/{apoderado_ci_esam}/g, apoderado_ci_esam);
          templatejurada = templatejurada.replace(/{apoderado_ci_ext_esam}/g, apoderado_ci_ext_esam);
          templatejurada = templatejurada.replace(/{representante_ci_exp}/g, expedido);
          templatejurada = templatejurada.replace(/{programa_monto_str}/g, programa_monto_str);
          templatejurada = templatejurada.replace(
            /{programa_monto_plus_matricula_str}/g,
            programa_monto_plus_matricula_str,
          );
          templatejurada = templatejurada.replace(/{programa_matricula_monto_str}/g, programa_matricula_monto_str);
          templatejurada = templatejurada.replace(/{programa_colegiatura_monto_str}/g, programa_colegiatura_monto_str);
          templatejurada = templatejurada.replace(
            /{programa_colegiatura_contado_str}/g,
            programa_colegiatura_contado_str,
          );
          templatejurada = templatejurada.replace(/{anio_str}/g, anio_str);
          templatejurada = templatejurada.replace(/{dia_cada_mes}/g, dia_cada_mes);
          templatejurada = templatejurada.replace(/{universidad_name}/g, universidad_name);
          templatejurada = templatejurada.replace(/{modalidad}/g, modalidad);
        }
        //template = template.replace(/{url_firma}/g, this.url_firma);
        //window.console.log('FIRMITAA:', this.url_firma); // myBase64 is the base64 string
        if (!this.url_firma.includes('/null') && !window.location.href.includes('webdev')) {
          this.toDataUrl(this.url_firma, function(myBase64) {
            //window.console.log(myBase64); // myBase64 is the base64 string
            template = template.replace(/{url_firma}/g, myBase64);
            preview.append(template);
            if (templatejurada) {
              templatejurada = templatejurada.replace(/{url_firma}/g, myBase64);
              previewjurada.append(templatejurada);
            }
            vue.loading = false;
          });
        } else {
          preview.append(template);
          previewjurada.append(templatejurada);
          vue.loading = false;
        }
        // window.console.log('template html:\n',template);
        //preview.append(template);
        this.inputcontrato = {
          ciudad: ciudad,
          direccion: this.sede.direccion,
          inscripcion_id: this.xinscripcion.id,
          modulos: xmodulos,
          participante: estudiante,
          participante_ci: carnet,
          participante_domicilio: domicilio,
          participante_id: this.xinscripcion.estudiante.id,
          participante_nacionalidad: nacionalidad,
          pdf: 'string',
          plan_pagos: xplanes,
          programa_carga_horario: programa_carga_horaria,
          programa_colegiatura_contado: xprograma_colegiatura_contado,
          programa_colegiatura_monto: xprograma_colegiatura_monto,
          programa_matricula_monto: xprograma_matricula_monto,
          programa_monto: xprograma_monto,
          programa_nombre: programa_nombre,
          programa_tipo: programa_tipo,
          representante: apoderado_esam,
          representante_ci: apoderado_ci_esam,
          representante_expedido: expedido,
        };
        //this.loading = false;
      },
      parsecomas(str) {
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      /*obtenerCodigoContrato() {
        const url = `${process.env.VUE_APP_API_REST}/api/v1/contratos/`;
        axios
          .post(url, this.inputcontrato)
          .then((res) => {
            window.console.log('SERVER: ', res);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },*/
      descargarOnlyPDFTest() {
        let vue = this;
        let estudiante = this.xinscripcion.estudiante.nombres + ' ' + this.xinscripcion.estudiante.pri_apellido;
        let elementoParaConvertir = window.$('#templatecontratopreview').html();
        if (this.only_file) {
          for (let j = 0; j < this.getcantidadcopias() - 1; j++) {
            // elementoParaConvertir += `<div class="html2pdf__page-break"></div>`;
            elementoParaConvertir += window.$('#templatecontratopreview').html();
          }
        }
        elementoParaConvertir = elementoParaConvertir.replace(/text-danger/g, '-');
        window
          .html2pdf()
          .set({
            margin: 1,
            filename: `Contrato ${estudiante}`,
            image: {
              type: 'jpeg',
              quality: 0.9,
            },
            html2canvas: {
              dpi: 92,
              scale: 3, // A mayor escala, mejores gráficos, pero más peso
              letterRendering: true,
            },
            pagebreak: { mode: 'css', after: '.html2pdf__page-break', avoid: ['p', 'li', 'div'] },
            jsPDF: {
              unit: 'in',
              format: 'Legal',
              orientation: 'portrait', // landscape o portrait
            },
          })
          .from(elementoParaConvertir)
          .toPdf()
          /*.output('datauristring')
          .then(function(pdfObj) {
            vue.thenpdf(pdfObj, filename, codigocontra);
          })*/
          .save()
          .catch((err) => {
            window.console.log(err);
            vue.loading = false;
          });
      },
      /*async descargarSladiaPDFTest() {
        let elementoParaConvertir = window.$('#templatecontratopreview').html();
        if (this.only_file) {
          for (let j = 0; j < this.getcantidadcopias() - 1; j++) {
            elementoParaConvertir += window.$('#templatecontratopreview').html();
          }
        }
        elementoParaConvertir = elementoParaConvertir.replace(/text-danger/g, '-');
        // window.console.log( elementoParaConvertir);

        let url = 'https://renderizador.sladia.site/api/pdf/from/html/render';
        let data = {
          html: elementoParaConvertir,
          footerHtml: "<div class=\"default-footer\"><div><span class=\"pageNumber\"></span> de <span class=\"totalPages\"></span></div></div>",
          options: {
            pageFormat: 'Letter',
            excludeBuiltinStyles: true,
          }
        }
        let config = {
          method: 'post', 
          url: url,
          headers: { 
            'Content-Type': 'application/json'
          },
          data : JSON.stringify(data),
          responseType: 'blob'
        };
        let res = await xaxios.request(config).then(res=>res).catch(e=>e);
        // window.console.log('res',res);

        const blobData = new Blob([res.data], { type: 'application/pdf' });
        const b642 = URL.createObjectURL(blobData);
        // window.console.log('b642',b642);

        let link = document.createElement("a");
        link.href = b642;
        link.download = 'pruebita.pdf';
        link.click();

      },*/

      async descargarpdf(codigoExistente=null,contrato_id=null) {
        if (!this.inputcontrato.participante_nacionalidad) {
          this.msg = 'El estudiante debe tener asignada una nacionalidad.';
          return;
        }
        if (this.inputcontrato.participante_nacionalidad == 'null') {
          this.msg = 'El estudiante debe tener asignada una nacionalidad.';
          return;
        }
        if (!this.inputcontrato.participante_domicilio || this.inputcontrato.participante_domicilio == 'null') {
          this.msg = 'El estudiante debe tener asignado un domicilio.';
          return;
        }
        if (this.xinscripcion.programa.programa_modulos.length == 0) {
          this.msg = 'Faltan los modulos del programa.';
          return;
        }
        if (this.programa_tipo == 'Diplomado' && this.xinscripcion.programa.programa_modulos.length < 5) {
          this.msg = 'Registre todos los modulos del programa, el diplomado debe tener al menos 5 modulos';
          return;
        }

        if (this.programa_tipo == 'Especialidad' && this.xinscripcion.programa.programa_modulos.length < 7) {
          this.msg = 'Registre todos los modulos del programa, la Especialidad debe tener al menos 7 modulos';
          return;
        }

        if (this.programa_tipo == 'Maestría' && this.xinscripcion.programa.programa_modulos.length < 10) {
          this.msg = 'Registre todos los modulos del programa, la Maestría debe tener al menos 10 modulos';
          return;
        }

        if(this.enviar_por_correo){
          let correo = this.correo_contrato;
          /* if(this.xinscripcion && this.xinscripcion.estudiante){
            correo = this.correo_contrato;
          } */
          if(!correo){
            this.msg = 'El estudiante debe tener asignado un correo electronico.';
            return;
          }
        }
        
        if (!this.inputcontrato.programa_matricula_monto) this.inputcontrato.programa_matricula_monto = 0;

        this.loading = true;
        this.msg = '';
        const vue = this;
        let pdfname =
          this.inputcontrato.participante + ' (' + this.xinscripcion.id + '-' + this.xinscripcion.programa.id + ')';
        let filename = 'contrato-' + pdfname + '.pdf';
        window.console.log(JSON.stringify(this.inputcontrato, null, 4));
        this.loading = true;

        /* VERIFICAR SI FUNCIONA */
        /**Al obtener el codigo asignar a la vista y descargar los contratos */
        //let codigocontra = 'jejejeje';
        let codigocontra = '';
        if(codigoExistente){
          codigocontra = {codigo:codigoExistente,contrato_id:contrato_id};
        }else{
          codigocontra = await xaxios
          .post(`${process.env.VUE_APP_API_REST}/api/v1/contratos/`, this.inputcontrato)
          .then(({ data }) => (data && data.data ? data.data : {}))
          .catch((e)=>e)
        }
        
        window.console.log('>codigocontra: ', codigocontra, filename);
        if(!codigocontra.codigo){
          this.loading = false;
          this.msg = 'No se pudo generar el codigo del contrato';
          try{
            this.msg = codigocontra.response.data.data;
          }catch(e){
            window.console.log(e)
          }

          return;
        }


        let preview = window.$('#templatecontratopreview');
        let previewjurada = window.$('#templatejuradapreview');
        let template = window.$('#templatecontratopreview').html();
        let templatejurada = window.$('#templatejuradapreview').html();
        template = template.replace(/{codigo_contrato}/g, codigocontra.codigo);
        templatejurada = templatejurada.replace(/{codigo_contrato}/g, codigocontra.codigo);
        preview.html(template);
        previewjurada.html(templatejurada);

        /* VERIFICAR SI FUNCIONA */

        let estudiante = this.xinscripcion.estudiante.nombres + ' ' + this.xinscripcion.estudiante.pri_apellido;
        let elementoParaConvertir = window.$('#templatecontratopreview').html();
        if (this.only_file) {
          for (let j = 0; j < this.getcantidadcopias() - 1; j++) {
            // elementoParaConvertir += `<div class="html2pdf__page-break"></div>`;
            elementoParaConvertir += window.$('#templatecontratopreview').html();
          }
        }
        elementoParaConvertir = elementoParaConvertir.replace(/text-danger/g, '-');
        window
          .html2pdf()
          .set({
            margin: 1,
            filename: `Contrato ${estudiante}`,
            image: {
              type: 'jpeg',
              quality: 0.9,
            },
            html2canvas: {
              dpi: 92,
              scale: 3, // A mayor escala, mejores gráficos, pero más peso
              letterRendering: true,
            },
            pagebreak: { mode: 'css', after: '.html2pdf__page-break', avoid: ['p', 'li', 'div'] },
            jsPDF: {
              unit: 'in',
              format: 'Legal',
              orientation: 'portrait', // landscape o portrait
            },
          })
          .from(elementoParaConvertir)
          //.toPdf()
          .output('datauristring')
          .then(function(pdfObj) {
            vue.thenpdf(pdfObj, filename, codigocontra);
          })
          //.save()
          .catch((err) => {
            window.console.log(err);
            vue.loading = false;
          });

        //this.crearpdfdoc();
      },
      thenpdf(pdfAsString, filename, codigocontra) {
        var arr = pdfAsString.split(',');
        pdfAsString = arr[1];
        let correo = this.correo_contrato;
        // correo = "eclipseconsol@gmail.com";

        let data = {
          contrato_id: codigocontra.contrato_id,
          is_enviar:this.enviar_por_correo,
          correo: correo,
          pdf: 'data:application/pdf;base64,' + pdfAsString,
        }; 
        window.console.log(data);
        // this.inputcontrato.pdf = 'data:application/pdf;base64,' + pdfAsString;
        this.crearpdfdoc(filename, data, codigocontra.codigo);
      },
      crearpdfdoc(filename, datasend, codigo) {
        const vue = this; 
        const url = `${process.env.VUE_APP_API_REST}/api/v1/contratos/pdf`;
        xaxios
          .post(url, datasend)
          .then((res) => {
            window.console.log('SERVER: ', res);
            vue.msg = res.data.data;
            const linkSource = datasend.pdf;
            const downloadLink = document.createElement('a');
            downloadLink.href = linkSource;
            downloadLink.download = filename;

            if (vue.only_file) {
              downloadLink.click();
            } else {
              for (let j = 0; j < vue.getcantidadcopias(); j++) {
                downloadLink.click();
              }
            }
            vue.loading = false;
            if (vue.msg.includes('exitoso')) {
              vue.generated = true;
            }
            if (vue.programa_tipo == 'Diplomado' && vue.xinscripcion.programa.universidad.id == 2) {
              if (vue.only_file) {
                vue.descargarDeclaracionJurada(codigo);
              } else {
                for (let j = 0; j < vue.getcantidadcopias() + 1; j++) {
                  vue.descargarDeclaracionJurada(codigo);
                }
              }
            }
          })
          .catch((error) => {
            window.console.error(error);
            vue.msg = 'Ha sucedido un error catastrofico. :(';
            if (error.response) {
              vue.msg = error.response.data.error;
            }
            vue.loading = false;
          });
      },
      descargarDeclaracionJurada(codigo) {
        let estudiante = this.xinscripcion.estudiante.nombres + ' ' + this.xinscripcion.estudiante.pri_apellido;
        let elementoParaConvertir = window.$('#templatejuradapreview').html();
        elementoParaConvertir = elementoParaConvertir.replace(/text-danger/g, '-');
        if (this.only_file) {
          for (let j = 0; j < this.getcantidadcopias(); j++) {
            elementoParaConvertir += `<div class="html2pdf__page-break"></div>`;
            elementoParaConvertir += window.$('#templatejuradapreview').html();
            elementoParaConvertir = elementoParaConvertir.replace(/text-danger/g, '-');
            elementoParaConvertir = elementoParaConvertir.replace(/{codigo_contrato}/g, codigo);
          }
        }
        window
          .html2pdf()
          .set({
            margin: 1,
            filename: `Declaracion ${estudiante}`,
            image: {
              type: 'jpeg',
              quality: 0.9,
            },
            html2canvas: {
              dpi: 96,
              scale: 3,
              letterRendering: true,
            },
            pagebreak: { mode: 'avoid-all' },
            jsPDF: {
              unit: 'in',
              format: 'letter',
              orientation: 'portrait',
            },
          })
          .from(elementoParaConvertir)
          .output('datauristring')
          .save()
          .catch((err) => {
            window.console.log(err);
          });
      },
      getmesstr(nummes) {
        if (nummes == 1) return 'enero';
        else if (nummes == 2) return 'febrero';
        else if (nummes == 3) return 'marzo';
        else if (nummes == 4) return 'abril';
        else if (nummes == 5) return 'mayo';
        else if (nummes == 6) return 'junio';
        else if (nummes == 7) return 'julio';
        else if (nummes == 8) return 'agosto';
        else if (nummes == 9) return 'septiembre';
        else if (nummes == 10) return 'octubre';
        else if (nummes == 11) return 'noviembre';
        else if (nummes == 12) return 'diciembre';
      },
      getfecha(fecha_pago) {
        if (!fecha_pago) return '-';
        let fs = fecha_pago.split('-');
        return `${fs[2]}-${fs[1]}-${fs[0]}`;
      },
      toDataUrl(url, callback) { 
        var img = new Image();
        img.crossOrigin = 'Anonymous';
        img.setAttribute('crossorigin', 'anonymous');
        img.onload = function() {
          var canvas = document.createElement('CANVAS');
          var ctx = canvas.getContext('2d');
          var dataURL;
          canvas.height = this.naturalHeight;
          canvas.width = this.naturalWidth;
          ctx.drawImage(this, 0, 0);
          dataURL = canvas.toDataURL('image/png');
          callback(dataURL);
          window.console.log('jejejej');
        };
        img.src = url;
        if (img.complete || img.complete === undefined) {
          img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
          img.src = url;
        }
      }, 
      subircontrato(pdf, filename) {
        const vue = this;
        let formData = new FormData();
        let url = `${process.env.VUE_APP_URL_WEBDATA}subir_contrato.php`;
        formData.append('file', pdf);
        formData.append('nombre', filename);
        var myHeaders = new Headers();

        fetch(url, { method: 'POST', headers: myHeaders, body: formData })
          .then((response) => {
            window.console.log(response);
            return response.text();
          })
          .then((result) => {
            vue.loading = false;
            window.console.log('contrato subida: ', result);
          })
          .catch((error) => {
            vue.loading = false;
            window.console.error('ERROR PDF LOAD:', error);
          });
      },

      descargarcontrato() {
        this.msg = '';
        let item = this.contratosaved.find((x) => x.inscripcion_id);
        if (!item) {
          this.msg = 'No se pudo obtener el contrato generado, no encontro la inscripcion en los contratos activos.';
          return;
        }

        this.loading = true;
        const vue = this;
        let contrato_id = item.id;
        let url3 = `${process.env.VUE_APP_API_REST}/api/v1/contratos/${contrato_id}/pdf`;
        xaxios
          .get(url3)
          .then((x) => {
            let datapdf = x.data.data;
            //window.console.log(datapdf);
            const downloadLink = document.createElement('a');
            downloadLink.href = datapdf;
            downloadLink.download = 'Contrato-' + item.participante + '.pdf';
            downloadLink.click();
            vue.loading = false;
            item.loading = false;
          })
          .catch((e) => {
            const r = e.response.data.data == 'sql: no rows in result set';
            vue.loading = false;
            item.loading = false;
            if(r){
              const codigo = vue.contratosaved[0].codigo;
              const contrato_id = vue.contratosaved[0].id;
              vue.descargarpdf(codigo,contrato_id);
            }
            window.console.error(e.response.data);
          });

        if (vue.programa_tipo == 'Diplomado' && vue.xinscripcion.programa.universidad.id == 2) {
          vue.descargarDeclaracionJurada('');
        }
      },
    },
    mounted() {
      this.msg = '';
      this.contratosaved = [];
      this.xinscripcion = JSON.parse(sessionStorage.getItem('xinscrito'));
      this.xinscripcion.programa = {};

      let prog = JSON.parse(sessionStorage.getItem('xprograma'));
      window.console.log('XINSSSSS', this.xinscripcion);
      //this.getpersonadata();
      this.getsede(prog.id);
    },
  };
</script>
